import React from "react";
import ReactDOM from "react-dom/client";
import Highcharts from "highcharts";
import HighchartsStock from "highcharts/highstock";
import { ConditionalAuthProvider } from "./auth/ConditionalAuthProvider";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

// Display all chart timestamps in the browser's local timezone (not UTC).
// Must be set on both highcharts and highcharts/highstock as they are separate instances.
const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
Highcharts.setOptions({ time: { timezone: localTz } });
HighchartsStock.setOptions({ time: { timezone: localTz } });

const isDevelopment = import.meta.env.DEV;

const AppWrapper = () => (
  <ConditionalAuthProvider>
    <App />
  </ConditionalAuthProvider>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  isDevelopment ? (
    <AppWrapper />
  ) : (
    <React.StrictMode>
      <AppWrapper />
    </React.StrictMode>
  ),
);
